import clsx from 'clsx';
import styles from './index.module.scss';

interface AnimatedHeightProps {
  isOpen: boolean;
  className?: string;
}

function AnimatedHeight({ isOpen, children, className }: React.PropsWithChildren<AnimatedHeightProps>) {
  return (
    <div className={clsx(styles.filterFormContainer, className)}>
      <div className={clsx(styles.animateHaight, isOpen && styles.animateHaightOpen)}>{children}</div>
    </div>
  );
}

export default AnimatedHeight;
